import 'core-js';
import 'custom-event-polyfill';
// import 'new-event-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
/* components */
import LeftSideBar from './components/left-side-bar/left-side-bar';
/* pages */
import AccessDeniedPage from './pages/access-denied/access-denied';
import ChangePasswordPage from './pages/change-password/change-password';
import ClientsFormPage from './pages/clients/clients-form';
import ClientsPage from './pages/clients/clients';
import EmailSentPage from './pages/forgot-password/email-sent';
import ErrorPage from './pages/error/error';
import ForgotPasswordPage from './pages/forgot-password/forgot-password';
import HomePage from './pages/home/home';
import LandingPage from './pages/landing/landing';
import LoggedOutPage from './pages/logged-out/logged-out';
import LoginPage from './pages/login/login';
import LoginEmailPage from './pages/login/login-email';
import LoginPasswordPage from './pages/login/login-password';
import PasswordChangedSuccess from './pages/password-changed-success/password-changed-success';
import RedirectPage from './pages/redirect/redirect';
import ResetPasswordErrorPage from './pages/reset-password/reset-password-error';
import ResetPasswordPage from './pages/reset-password/reset-password';
import SamlFormPage from './pages/schemes/saml-form';
import SchemesFormPage from './pages/schemes/schemes-form';
import SchemesPage from './pages/schemes/schemes';
import ScopesFormPage from './pages/scopes/scopes-form';
import ScopesPage from './pages/scopes/scopes';
import SystemUsersPage from './pages/system-users/system-users';
import SystemUserFormPage from './pages/system-users/system-user-form';

import './assets/fonts/sten-icons/font-sten-icons.scss';
import './assets/fonts/roboto/font-roboto.scss';
import './assets/styles/app.scss';

import Helmet from 'react-helmet';

global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;

global.Helmet = Helmet;

global.LeftSideBar = LeftSideBar;

global.AccessDeniedPage = AccessDeniedPage;
global.ChangePasswordPage = ChangePasswordPage;
global.ClientsFormPage = ClientsFormPage;
global.ClientsPage = ClientsPage;
global.EmailSentPage = EmailSentPage;
global.ErrorPage = ErrorPage;
global.ForgotPasswordPage = ForgotPasswordPage;
global.HomePage = HomePage;
global.LandingPage = LandingPage;
global.LoggedOutPage = LoggedOutPage;
global.LoginPage = LoginPage;
global.LoginEmailPage = LoginEmailPage;
global.LoginPasswordPage = LoginPasswordPage;
global.PasswordChangedSuccess = PasswordChangedSuccess;
global.RedirectPage = RedirectPage;
global.ResetPasswordErrorPage = ResetPasswordErrorPage;
global.ResetPasswordPage = ResetPasswordPage;
global.SamlFormPage = SamlFormPage;
global.SchemesFormPage = SchemesFormPage;
global.SchemesPage = SchemesPage;
global.ScopesFormPage = ScopesFormPage;
global.ScopesPage = ScopesPage;
global.SystemUsersPage = SystemUsersPage;
global.SystemUserFormPage = SystemUserFormPage;
